import { WRONG_PHONE_NOTIFICATION } from 'consts';
import { CheckCodeData, FormNotifications, StepperStep, CurrentUser, VerifyPhoneNumberData } from 'types';
import { CheckCodeNotification } from '../CheckCodeNotification';
import { ResendCode } from 'components/ResendCode';
import { ResetPhone } from '../../../components/ResendCode/ResendCode';

export const getInitialPhoneNumberStep = (
  user: CurrentUser,
  notifications: Record<string, FormNotifications>,
  onPass: (data: VerifyPhoneNumberData) => void,
) => ({
  stepName: 'Phone Number',
  onPass: async (data: VerifyPhoneNumberData) => {
    onPass(data);
  },
  formProps: {
    notifications: notifications,
    buttonCaption: 'Text me the code',
    fields: [
      {
        type: 'notification',
        fieldName: 'signUpStep0_0',
      },
      {
        type: 'title',
        fieldName: 'title',
        value: 'Enter your phone number',
      },
      {
        type: 'descriptionDark',
        fieldName: 'description',
        value: 'We may send you a one-time password to verify your phone number. By providing your phone number you agree to receive important text messages from SENDY regarding offers and sales. We will never spam you.',
      },
      {
        type: 'phone',
        fieldName: 'phone',
        placeholder: 'Phone Number *',
        value: user.phone || user.uncheckedPhone,
        required: true,
        errorMessage: WRONG_PHONE_NOTIFICATION,
        validator: (value: string | number | boolean) => !!value,
      },
    ],
  },
});

export const getCheckingPhoneNumberStep = (
  user: any,
  notifications: Record<string, FormNotifications>,
  changePhoneCallback: () => void,
  resendCodeCallback: () => void,
  goToNextStep: (newUser: CheckCodeData) => void,
): StepperStep => ({
  stepName: 'Phone Number',
  isHidden: true,
  onPass: async (data: CheckCodeData) => {
    goToNextStep(data);
  },
  formProps: {
    notifications: notifications,
    header: 'Phone Verification',
    buttonCaption: 'Verify and Continue',
    fields: [
      {
        type: 'notification',
        fieldName: 'signUpStep0_1',
      },
      {
        type: 'title',
        fieldName: 'title',
        value: 'Phone Verification',
      },
      {
        type: 'component',
        fieldName: 'resent',
        child: <ResetPhone phone={user.uncheckedPhone} changePhoneCallback={changePhoneCallback} />,
      },
      {
        type: 'codeVerification',
        fieldName: 'code',
        placeholder: 'Confirm Password',
        sellBig: true,
        required: true,
      },
      {
        type: 'component',
        fieldName: 'resent',
        child: <ResendCode onResend={resendCodeCallback} />,
      },
    ],
  },
});
